import api from "./api";

// Allocates a physical bin to an EXISTING product SKU. Never mints a new SKU —
// create/scan the item first (Smart Scan / Add Product), then allocate it here.
export async function allocateLocation(payload) {
  const res = await api.post("/api/inventory/allocate", payload);
  return res.data;
}

export async function barcodeLookup(barcode) {
  const res = await api.post("/api/inventory/barcode-lookup", { barcode });
  return res.data?.item;
}

// Returns the full paged shape ({items, total, limit, offset}) so callers can
// build "load more" pagination instead of fetching everything at once.
export async function getItems(params = {}) {
  const res = await api.get("/api/inventory/items", { params });
  return {
    items: res.data?.items || [],
    total: res.data?.total || 0,
    limit: res.data?.limit || params.limit || 24,
    offset: res.data?.offset || params.offset || 0,
  };
}

// Products that exist but have no active ("stored") bin yet.
export async function getUnallocatedItems(params = {}) {
  const res = await api.get("/api/inventory/unallocated", { params });
  return {
    items: res.data?.items || [],
    total: res.data?.total || 0,
    limit: res.data?.limit || params.limit || 24,
    offset: res.data?.offset || params.offset || 0,
  };
}

// Frees the SKU's current bin (occupancy -1) and takes it off the Allocated
// Articles list. The SKU itself (product) is untouched — it just needs
// re-allocating next.
export async function removeAllocation(sku) {
  const res = await api.post("/api/inventory/remove-allocation", { sku });
  return res.data;
}
